if (window.innerWidth < 768) {
    $('html').removeClass('has-filters');
    $('#mainWrapper').removeClass('has-filters');
}
